var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wave",class:`loader-wave--${_vm.size}`},_vm._l((_vm.colors),function(color){return _c('span',{key:color,staticClass:"loader-wave__circle",class:`loader-wave__circle--${_vm.size}`,style:({ background: color })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }